<tvsub-step-container (action)="onAction($event)" [denyPrevious]="true" [step]="step" [steps]="STEPS">
	@if (form) {
		<form [formGroup]="form" class="u-width--md">
			<tvcore-checkbox [control]="form.get('accept')" name="accept">Ik heb de {{ handleiding() }} ‘{{ name() }}’ volledig gelezen.</tvcore-checkbox>

			@if (showErrors && form.get('accept').errors) {
				<p class="u-text--sm u-text--error">Dit is verplicht.</p>
			}

			<div class="u-m-top--sm">
				We raden je aan om de {{ handleiding() }} ‘{{ name() }}’ volledig te lezen vóór je een subsidieaanvraag indient. Deze handleiding vind je terug op <a [href]="manual()" target="_blank">de website</a>.
			</div>
		</form>
	}
</tvsub-step-container>
